import { AuthContext, FooterLink } from '@core/shared';
import { ErrorMessage, Page } from '@core/ui';
import { Outlet, useLocation } from '@online-webinar/router';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '../Footer';

interface Props {
    footerLinks: FooterLink[];
}

export const Content = ({ footerLinks }: Props) => {
    const { t } = useTranslation();
    const { isAuthenticated, isMainAccount, activeAccount } = useContext(AuthContext);

    const PagesWithNoFooter = ['broadcast', 'on-demand', 'slide-controller', 'view', 'watch'];
    const location = useLocation();

    let footerbarVisible = true;
    const parts = location.pathname.split('/');
    if (parts.length > 2) {
        const pageName = parts[2];
        if (PagesWithNoFooter.includes(pageName)) {
            footerbarVisible = false;
        }
    }

    return (
        <Page>
            {isAuthenticated && !isMainAccount && activeAccount && (
                <div id="account-bar" className="sticky top-0 bg-stripes bg-size-[16px_16px] p-2 z-10">
                    <p className="bg-accent-light rounded-button inline-block m-0 p-2">
                        {t('Account.Bar.Text')} {activeAccount.profile.nickname}
                    </p>
                </div>
            )}
            <noscript data-nosnippit>
                <span data-nosnippit>
                    <ErrorMessage errorSubject="Javascript" errorCode="Required" />
                </span>
            </noscript>
            <Outlet />
            {footerbarVisible && <Footer footerLinks={footerLinks} />}
        </Page>
    );
};
